import { render } from "./MMessageTemplateSheet.vue?vue&type=template&id=32a3636d&scoped=true&ts=true"
import script from "./MMessageTemplateSheet.vue?vue&type=script&lang=ts"
export * from "./MMessageTemplateSheet.vue?vue&type=script&lang=ts"

import "./MMessageTemplateSheet.vue?vue&type=style&index=0&id=32a3636d&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a3636d"]])

export default __exports__